import { jsx as _jsx } from "react/jsx-runtime";
import { CxmEntityType, getShowtimesForEvent, loadCxmFilmsForComponent, LoadingState, loadShowtimesForEvent } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { ShowtimePicker } from '../../subcomponents/showtime-picker/showtime-picker';
import { getFilmIdsForShowtimes, handleApiError } from '../../subcomponents/showtime-picker/utils/showtime-picker-utils';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { defaultEventShowtimePickerProps, eventShowtimePickerPropsValidator } from './types/props';
import { setupFilter } from './utils/setup-filter';
import { validateShowtimePickerData } from './utils/validate';
const b = bemClassBuilder('v-event-showtime-picker');
export const EventShowtimePicker = observer(props => {
    const { eventId, filmIds, siteId, config } = props;
    const { filter, componentId } = config;
    const [apiErrorMessageType, setApiErrorMessageType] = useState();
    const [filmsLoadingState, setFilmsLoadingState] = useState(LoadingState.Loading);
    const filterId = filter === null || filter === void 0 ? void 0 : filter.filterId;
    useEffect(() => {
        (async () => {
            setApiErrorMessageType(undefined);
            setFilmsLoadingState(LoadingState.Loading);
            try {
                await Promise.all([
                    loadShowtimesForEvent(eventId, siteId),
                    loadCxmFilmsForComponent(CxmEntityType.FilmShowtimePicker, componentId)
                ]);
                setupFilter(eventId, siteId, filter);
                setFilmsLoadingState(LoadingState.Success);
            }
            catch (error) {
                setApiErrorMessageType(handleApiError(error));
                setFilmsLoadingState(LoadingState.Failure);
            }
        })();
    }, [componentId, eventId, filter, siteId]);
    const showtimes = getShowtimesForEvent(eventId, siteId, filterId);
    const filmIdsToDisplay = filmIds || getFilmIdsForShowtimes(showtimes);
    // Check for invalid states - e.g. empty data, or no sites selected.
    const invalidStateMessage = apiErrorMessageType
        ? { messageType: apiErrorMessageType }
        : validateShowtimePickerData(siteId, filmIdsToDisplay, filmsLoadingState, config, filmIds);
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(ShowtimePicker, Object.assign({}, props, { config: config, showtimes: showtimes, filmsLoadingState: filmsLoadingState, filmIds: filmIdsToDisplay, siteIds: [siteId], groupShowtimesByDate: true, invalidStateMessage: invalidStateMessage })) })));
});
EventShowtimePicker.displayName = 'EventShowtimePicker';
/**
 * The **Event Showtime Picker** component renders a list of showtimes for a given set of films and a site and an event.
 */
export const EventShowtimePickerComponent = withComponentWrapper(EventShowtimePicker, defaultEventShowtimePickerProps, eventShowtimePickerPropsValidator);
